import { request } from '@max/meituan-uni-network';
const defaultParams = {
    // __reqTraceID: '2065D4B6-1403-4F89-AEC9-3309911407AF',
    // channel: 'meituan',
    cityHotWord: 'true',
    designRevisionType: 'visual_redesign_2021',
    mainEntrance: '1',
    language: 'zh-CN'
    // ci: '1',
    // gps_cityid: '1',
    // keyword: '北京',
    // lat: '40.007406526232806',
    // lng: '116.48937210655102',
    // mainEntrance: '0',
    // msid: '80FC353C-88A3-450B-AB28-2DEC6E4CD09C1656660721769792',
    // utm_campaign: 'AgroupBgroupGhomepage_category3_20__a1__c__e0H0',
    // utm_content: '0000000000000C97E2EFA9AE2465F9A3D8CC9C6046E1BA162733273207024159',
    //utm_medium: 'iphone',
    // utm_source: 'Alpha',
    // utm_term: '12.0.200',
    // uuid: '0000000000000C97E2EFA9AE2465F9A3D8CC9C6046E1BA162733273207024159',
    // version_name: '12.0.200',
    // osversion: '15.5',
    // cn_pt: 'RN',
    // client: 'iphone',
};
var AreaSuggestHost;
(function (AreaSuggestHost) {
    // Test = 'https://api.hotel.test.sankuai.com',
    AreaSuggestHost["Prod"] = "https://ihotel.meituan.com";
})(AreaSuggestHost || (AreaSuggestHost = {}));
export const getAreaSuggest = (params, success, fail) => {
    // const Host = isProductionEnv() ? AreaSuggestHost.Prod : AreaSuggestHost.Test;
    const Host = AreaSuggestHost.Prod;
    return request({
        url: `${Host}/hbsearch/v2/AreaSuggest`,
        method: 'GET',
        data: Object.assign(Object.assign({}, params), defaultParams),
        header: {
            'content-type': 'application/json'
        },
        success,
        fail
    });
};
